import { IntlShape } from 'react-intl'
import { create, enforce, test } from 'vest'
import { Template } from '../typings'
import { messages } from './messages'

export function validationSuite(intl: IntlShape) {
  return create(({ name }: Template) => {
    const { $t } = intl
    const { validation } = messages

    test('name', $t(validation.required), () => {
      enforce(name).isNotEmpty()
    })
  })
}
